module.exports = __webpack_public_path__ + "img/一堆金币2.58083244.png";